import { render, staticRenderFns } from "./standardList.vue?vue&type=template&id=179c65e6&scoped=true"
import script from "./standardList.vue?vue&type=script&lang=js"
export * from "./standardList.vue?vue&type=script&lang=js"
import style0 from "./standardList.vue?vue&type=style&index=0&id=179c65e6&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./standardList.vue?vue&type=style&index=1&id=179c65e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179c65e6",
  null
  
)

export default component.exports